import { r4Client, r4Error } from '@/services'

const EmailPreviewApi = {

  async _createPreviewEmail (payload) {
    const resp = await r4Client().post('/api/v1/email_preview', payload)
    return resp.data
  },

  async sendEmailCampaignPreviewEmail (recipientEmails, emailCampaignData) {
    const payload = {
      preview_type: 'email_campaign',
      recipient_emails: recipientEmails,
      email_campaign_data: emailCampaignData
    }

    try {
      return await this._createPreviewEmail(payload)
    } catch (error) {
      throw r4Error(error)
    }
  },

  async sendTemplatePreviewEmail (recipientEmails, dealerId, rooftopId, htmlBody, emailTemplateId = null) {
    const previewParams = {
      preview_type: 'email_template',
      recipient_emails: recipientEmails,
      template_html: htmlBody,
      dealer_id: dealerId,
      dealer_rooftop_id: rooftopId,
      email_template_footer_id: emailTemplateId
    }
    try {
      return await this._createPreviewEmail(previewParams)
    } catch (error) {
      throw r4Error(error)
    }
  }
}

export default EmailPreviewApi
